module.exports = __webpack_public_path__ + "static/graphql-46e88b2957bc7de3f0c510da9bbc0d45.png";